/**
 * 快捷键作用域图层，栈从低到高：app < page < dialog < widget
 */
export const ShortcutLayer = {
  APP: 'app',
  PAGE: 'page',
  DIALOG: 'dialog',
  WIDGET: 'widget',
}

/**
 * 全局默认命令名（Phase 1 不绑定，供后续替换 plugins/keyboard.js）
 */
export const APP_DEFAULT_COMMANDS = {
  f10: 'add',
  f4: 'save',
  f6: 'record',
  p: 'print',
  f8: 'fastAdd',
  esc: 'cancel',
  up: 'up',
  down: 'down',
  q: 'enable',
  d: 'remove',
  f3: 'customerChange',
}
